const Downloader = () => {
     const downloadCsv = (feed, name) => {
        if(!feed || !feed.data) return;
        const SEPARATOR = ','
        var element = document.createElement('a');
        var lines = [feed.cols.join(',')]
        lines = lines.concat(feed.data.map(row => row.map(d => {
            if(d instanceof Date)
                return d.toISOString()
            else if(typeof d === 'string' && d.includes(SEPARATOR))
                return '"'+d+'"'
            else
                return d;
        }).join(SEPARATOR)))
        var csv = lines.join('\n')
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
        element.setAttribute('download', name + '.csv');
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    return {
         downloadCsv:downloadCsv
    }
}

export default Downloader